export enum STATUS {
  PASSIVE = 0,
  ACTIVE = 1,
  CANCEL = 2,
  PENDING = 3,
  DRAFT = 4,
  REJECTED = 5,
}
